<template>
    <div id="pwaPanel">
        <popup ref="popup" type="center" @close="popClose">
            <div class="pwa_panel">
                <div class="panel_title">欢迎来到懒人办公</div>
                <div class="panel_subtitle">建议您先把懒人办公放到电脑桌面，因为下次使用更便捷</div>
                <div class="panel_content">
                    <div class="panel_item install">
                        <div class="item_top">超过 90% 新注册用户选择安装</div>
                        <div class="item_content">
                            <div class="content_text">无需下载，整个过程仅需一秒</div>
                            <div class="step_btn" @click="installNow">第一步：点此开始</div>
                            <div class="content_text">第二步：点击浏览器右上角弹出的<span class="install_btn">安装</span>即可</div>
                            <div class="content_tips">目前有658749832123位用户把懒人办公放到电脑桌面</div>
                        </div>
                    </div>
                    <div class="panel_item">
                        <div class="item_top"></div>
                        <div class="item_content">
                            <div @click="popClose" class="skip">已安装，点此跳过<i class="el-icon-d-arrow-right"></i></div>
                        </div>
                    </div>
                </div>
                <div class="close_btn" @click="popClose"></div>
            </div>
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    export default {
        components:{popup},
        data() {
            return {
                
            }
        },
        created() {
        
        },
        methods: {
            show(){
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.popup.close();
                let user_id = localStorage.getItem("user_id")||0;
                //埋点
                // zjzBrowseRecord({user_id:user_id, mod_code:"p001"})
            },
            installNow(){
                deferredPrompt.prompt()
                this.popClose();
                let user_id = localStorage.getItem("user_id")||0;
                deferredPrompt.userChoice.then(function(e) {
                    if (e.outcome === 'dismissed'){
                        // 不允许
                        //埋点
                        // zjzBrowseRecord({user_id:user_id, mod_code:"p003"})
                    } else {
                        // 允许
                        //埋点
                        // zjzBrowseRecord({user_id:user_id, mod_code:"p002"})
                    }
                })
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .pwa_panel{
        width: 1000px;
        height: 600px;
        position: relative;
        padding: 34px 70px;
        text-align: center;
        background-color: #fff;
        border-radius: 3px;
        .panel_title{
            font-size: 28px;
            line-height: 66px;
        }
        .panel_subtitle{
            font-size: 15px;
            line-height: 53px;
            color: #999;
        }
        .panel_content{
            padding-top: 40px;
            display: flex;
            .panel_item{
                flex-grow: 1;
                width: 0;
                &.install{
                    margin-right: 22px;
                    font-size: 12px;
                    .item_top{
                        border: 1px solid #ccc;
                        background-color: #f5f5f5;
                        line-height: 50px;
                        position: relative;
                        color: #999;
                        border-radius: 3px;
                        &::after{
                            content: "";
                            position: absolute;
                            display: block;
                            width: 14px;
                            height: 14px;
                            border: 1px solid #ccc;
                            border-top-color: transparent;
                            border-left-color: transparent;
                            left: 50%;
                            bottom: -7px;
                            box-sizing: border-box;
                            transform-origin: center;
                            transform: rotate(45deg);
                            background-color: #f5f5f5;
                        }
                    }
                    .item_content{
                        background-color: #f5f5f5;
                        .content_text{
                            line-height: 76px;
                            .install_btn{
                                display: inline-block;
                                vertical-align: middle;
                                height: 26px;
                                line-height: 26px;
                                width: 46px;
                                margin: -2px 18px 0;
                                border-radius: 3px;
                                border: 1px solid #ccc;
                            }
                        }
                        .step_btn{
                            width: 280px;
                            margin: 0 auto;
                            height: 50px;
                            line-height: 50px;
                            color: #fff;
                            background-color: #424242;
                            border-radius: 3px;
                            margin-bottom: 7px;
                        }
                        .content_tips{
                            color: #999;
                            line-height: 26px;
                        }
                    }
                }
                .item_top{
                    height: 50px;
                    margin-bottom: 11px;
                }
                .item_content{
                    height: 270px;
                    border-radius: 3px;
                    border: 1px solid #ccc;
                    position: relative;
                    .skip{
                        color: #cccccc;
                        font-size: 14px;
                        cursor: pointer;
                        position: absolute;
                        top: 50%;
                        line-height: 28px;
                        margin-top: -14px;
                        width: 100%;
                    }
                }
            }
        }
        .close_btn{
            position: absolute;
            bottom: -61px;
            left: 50%;
            transform: translateX(-50%);
            width: 25px;
            height: 25px;
            background-image: url("./img/update_close.png");
            cursor: pointer;
            background-size: 100% 100%;
        }
    }
</style>